import Vue from 'vue';

const filters = {
  parseTime(timeStamp, showSeconds) {
    function add0(val) {
      return val >= 10 ? val : '0' + val;
    }
    if (!timeStamp) {
      return;
    }
    const date = new Date(timeStamp);
    return `${date.getFullYear()}-${add0(date.getMonth() + 1)}-${add0(date.getDate())} ${add0(date.getHours())}:${add0(
      date.getMinutes()
    )}${showSeconds ? ':' + add0(date.getSeconds()) : ''}`;
  },

  parsePrescriptionStatus(code) {
    // console.log('code', code, Constant.prescriptionStatus[0]);
    if (code || code === 0) {
      return Constant.prescriptionStatus[code];
    }
  },

  addImagePrefix(value) {
    // 如果有前缀返回原值
    if (/^(https?):\/\/.*.*/.test(value)) return value;
    const map = {
      online: '//static-volc.91jkys.com/',
      pre: '//static.pre.91jkys.com/',
      qa: '//static.qa.91jkys.com/'
    };
    return map[Util.getEnv()] + value;
  },
  parseBoolean(value) {
    if (value === true) {
      return '是';
    } else if (value === false) {
      return '否';
    } else {
      return '';
    }
  },
  fen2Yuan(fen) {
    // 安全需求 没l3权限返回 *
    if (fen === '﹡') return '*';
    fen = Number(fen);
    if (!fen && fen !== 0) return null;
    return (fen / 100).toFixed(2);
  }
};
export const Sex = sex => {
  if (sex === 1) {
    return '男';
  } else if (sex === 0) {
    return '女';
  } else {
    return '';
  }
};
export default filters;
